var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultGlobalPageProperties, defaultVideoProperties, } from "./SegmentHelper";
import { getPageLoginState, recursiveMerge } from "./CommonHelper";
import { NewRelicEvents } from "./Enums";
export var getDefaultEventProps = function () {
    var _a, _b, _c, _d, _e;
    var account = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getAccount();
    var anonymousAccount = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getAnonymousAccount();
    var pageLoginState = getPageLoginState(account);
    var mergedProps = recursiveMerge(defaultGlobalPageProperties, {
        authentication_status: !!account,
        dma: (account === null || account === void 0 ? void 0 : account.dma) || (anonymousAccount === null || anonymousAccount === void 0 ? void 0 : anonymousAccount.dma),
        event_type: "app",
        mvpd: (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getMVPD(),
        page_type: (_e = (_d = window.utag) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.page_type,
        page_login_state: pageLoginState,
        profile_id: (account === null || account === void 0 ? void 0 : account.profileId) || (anonymousAccount === null || anonymousAccount === void 0 ? void 0 : anonymousAccount.profileId),
    });
    return mergedProps;
};
var LogReport = /** @class */ (function () {
    function LogReport(_a) {
        var datadogRum = _a.datadogRum;
        var trackingProps = getDefaultEventProps();
        datadogRum.setGlobalContext(trackingProps);
        this.datadogRum = datadogRum;
    }
    LogReport.prototype.reportError = function (error, props) {
        if (error === void 0) { error = {}; }
        if (props === void 0) { props = {}; }
        var customAttributes = __assign({ errorServerResponse: error.status }, props);
        this.datadogRum.addError(error, customAttributes);
    };
    LogReport.prototype.reportErrorInPlayer = function (error, props) {
        if (error === void 0) { error = {}; }
        if (props === void 0) { props = {}; }
        this.reportError(error, __assign(__assign({}, defaultVideoProperties), props));
    };
    LogReport.prototype.logEvent = function (event, props) {
        if (props === void 0) { props = {}; }
        var eventName = NewRelicEvents[event];
        this.datadogRum.addAction(eventName, props);
    };
    LogReport.prototype.logPlayerEvent = function (event, props) {
        if (props === void 0) { props = {}; }
        var playerProps = recursiveMerge(defaultVideoProperties, props);
        this.logEvent(event, playerProps);
    };
    return LogReport;
}());
export default LogReport;
